/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React, { useState, useEffect, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import CustomSeparator from '../../../../SharedModules/Breadcrumbs/BreadcrumbsComponent';
import DisplayErrorMessages from '../../../../SharedModules/Errors/ErrorMessages';
import DisplaySuccessMessages from '../../../../SharedModules/Errors/SuccessMessage';
import Spinner from '../../../../SharedModules/Spinner/Spinner';
import PeriodicReportHeader from './Components/PeriodicReportHeader';
import { setErrorMessages, setSuccessMessages } from './store/actions';
import { API_TIMEOUT_ERROR } from '../../../../SharedModules/Errors/constantMessageData';
const PeriodicReport = ({}) => {
  const dispatch = useDispatch();

  const errorMessages = useSelector(
    (state) => state?.sharedState?.PeriodicReportReducer?.errorMessages
  );
  const successMessages = useSelector(
    (state) => state?.sharedState?.PeriodicReportReducer?.successMessages
  );
  const selectType = useSelector(
    (state) => state?.sharedState?.PeriodicReportReducer?.selectType
  );
  const isNetworkError = useSelector(
    (state) => state?.sharedState?.PeriodicReportReducer?.isNetworkError
  );
  const [loading, setLoading] = useState(false);
  const [openNetworkModal, setOpenNetworkError] = useState(false);
  const dispatchErrorMessages = useCallback(
    (messages) => {
      dispatch(setErrorMessages(messages));
    },
    [errorMessages]
  );

  const dispatchSuccessMessages = useCallback(
    (messages) => {
      dispatch(setSuccessMessages(messages));
    },
    [successMessages]
  );
  useEffect(() => {
    setOpenNetworkError(isNetworkError);
  }, [isNetworkError]);
  // handling refresh functionality
  useEffect(() => {
    const updateTabs = JSON.parse(localStorage.getItem('tabItemsData'));
    const newObj =
      updateTabs &&
      updateTabs.length > 0 &&
      updateTabs.map((item) => {
        if (item.navTo === '/periodicBalanceRpt') {
          if (errorMessages?.length > 0) {
            item.isFormError = true;
          } else {
            item.isFormError = false;
          }
        }
        return item;
      });
    localStorage.setItem('tabItemsData', JSON.stringify(newObj));
  }, [errorMessages]);

  return (
    <div className="tabs-container tBillPanel custom-check">
      {loading && <Spinner load={loading} />}

      <CustomSeparator parent1="System" parent2="Periodic Balance Rpt" />
      {openNetworkModal && (
        <DisplayErrorMessages errorMessages={[API_TIMEOUT_ERROR]} />
      )}
      {successMessages && (
        <DisplaySuccessMessages successMessages={successMessages} />
      )}
      {errorMessages && selectType === 'cumulative' && (
        <DisplayErrorMessages
          errorMessages={errorMessages.map((item) =>
            item?.message?.replace(
              /To date is required./g,
              'End date is required for generating Cumulative Report.'
            )
          )}
        />
      )}
      {errorMessages && selectType === 'single' && (
        <DisplayErrorMessages
          errorMessages={errorMessages.map((item) =>
            item?.message === 'To date is required.'
              ? item?.message?.replace(
                  /To date is required./g,
                  'End date is required for generating Single Period Report.'
                )
              : item?.message?.replace(
                  /From date is required./g,
                  'Start date is required for generating Single Period Report.'
                )
          )}
        />
      )}

      <PeriodicReportHeader
        setErrorMessages={dispatchErrorMessages}
        setSuccessMessages={dispatchSuccessMessages}
        setLoading={setLoading}
      />
    </div>
  );
};
export default PeriodicReport;
